import React, { Suspense, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import StructuredData from './components/StructuredData';
import { trackPageView } from './utils/analytics';

// Lazy load components for code splitting
const About = React.lazy(() => import('./components/About'));
const PlayerPathway = React.lazy(() => import('./components/PlayerPathway'));
const Honors = React.lazy(() => import('./components/Honors'));
const Gallery = React.lazy(() => import('./components/Gallery'));
const Partners = React.lazy(() => import('./components/Partners'));
const Schedule = React.lazy(() => import('./components/Schedule'));
const Contact = React.lazy(() => import('./components/Contact'));

// Loading component
const LoadingFallback = () => (
  <div className="loading-fallback">
    <div className="loading-spinner"></div>
  </div>
);

function App() {
  useEffect(() => {
    // Initialize Google Analytics (replace with your measurement ID)
    // initGA('G-XXXXXXXXXX');
    
    // Track initial page view
    trackPageView(window.location.pathname);
    
    // Track hash changes (for single-page navigation)
    const handleHashChange = () => {
      trackPageView(window.location.pathname + window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="App">
      <StructuredData />
      <Header />
      <Hero />
      <Suspense fallback={<LoadingFallback />}>
        <About />
        <PlayerPathway />
        <Honors />
        <Gallery />
        <Partners />
        <Schedule />
        <Contact />
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;

